module.exports = __webpack_public_path__ + "img/4.c8acb009.jpg";